import { Injectable } from '@angular/core';
import {BaseWizardService} from "../base.wizard.service";
import { ApiService, InputDatastoreService, CountryListService, DialogService } from '@nrwl/common-lib';

@Injectable({
  providedIn: "root"
})
export class MachineLearningResetWizardService extends BaseWizardService {
  constructor(
    apiService: ApiService,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService
  ) {
    super(apiService, inputDatastoreService, countryListService, dialogService);
  }

  openWizard(wizardId,
    wizardConfig,
    defaultParamsById = {subTitle: ''},
    onSuccess = () => {
    },
    onFail = () => {
    }) {
      defaultParamsById.subTitle = wizardConfig.valuesFixed.stepsInfo;
      super.openWizard(wizardId, wizardConfig, defaultParamsById, onSuccess, onFail);
    }

    onApply(): any {
      return this.currentStep.output;
    }

}
